 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"7ba0e832607d0aa34fd3ebc09a03478bb7bac399","3":"c54ed03dbb5080e29b73f5cd699bbd2e6eb790cb","4":"29107295","5":"2250b53de61967a6264ef34daecfaae1ed32318b","7":"1a48f3500bfa2859c4c1d2b6b8d5e7f120402f3c","8":"framework","9":"4d4504f70e65bac4eb17d17380682e636cafe956","10":"742908874d139db3cdc84588064a532f1fc4363c","11":"7c89d84ff08ed2d15d93c4f3a12cda655939f09c","12":"fe03665ab55fd2276f5453ba23bb7f6ee7d5a005","17":"component---src-pages-404-js","18":"component---src-pages-about-js","19":"component---src-pages-brands-amplify-js","20":"component---src-pages-brands-index-js","21":"component---src-pages-brands-shops-js","22":"component---src-pages-brands-stack-media-js","23":"component---src-pages-brands-stackagency-js","24":"component---src-pages-case-study-entrepreneur-js","25":"component---src-pages-contact-js","26":"component---src-pages-index-js","27":"component---src-pages-publishers-affiliate-js","28":"component---src-pages-publishers-content-studio-js","29":"component---src-pages-publishers-index-js","30":"component---src-pages-publishers-self-serve-shops-js","31":"component---src-pages-publishers-shops-js","32":"component---src-pages-publishers-stack-media-js","33":"component---src-pages-publishers-stackagency-js","34":"component---src-templates-page-template-js","35":"components-sections-BrandsAmplifyDefer","36":"components-sections-BrandsIndexDefer","37":"components-sections-BrandsShopsDefer","38":"components-sections-BrandsStackAgencyDefer","39":"components-sections-BrandsStackMediaDefer","40":"components-sections-HomeDefer","41":"components-sections-PublishersAffiliateDefer","42":"components-sections-PublishersContentStudioDefer","43":"components-sections-PublishersIndexDefer","44":"components-sections-PublishersSelfShopsDefer","45":"components-sections-PublishersShopsDefer","46":"components-sections-PublishersStackAgencyDefer","47":"components-sections-PublishersStackMediaDefer","48":"forms-FooterNewsletter"}[chunkId]||chunkId) + "-" + {"0":"8657e1e6cced9dc48c1e","1":"1f9520ddb0a369677e59","2":"26beea539927c0947def","3":"3f2ebfa90abb15b8548e","4":"e8d8fd28a4101d28ed6a","5":"f47aa5a034b499b21070","6":"f0c20413aace386a4c7e","7":"c031d8fb79502ec1a157","8":"b1705ca9aec85c909033","9":"e44e70d79e674e538f13","10":"50695ade8b2a4b304ead","11":"b150ecee1c39ba6a0332","12":"8ef40666afe0559d1341","17":"3fd85392840db7b97f6a","18":"77dac18fc955ceea39f1","19":"248a3b6dcaaa55f693c2","20":"d25bf68218af494580b5","21":"af48a8fdd71ea787a2bf","22":"2a77ab741d748b84e55f","23":"3170edb208383d282ef0","24":"a431f89b419088eef002","25":"4a59866a02630b226fec","26":"9c062b435f86105cffa4","27":"d6887bc60a1cde839dfa","28":"475d41ff04712414bb24","29":"e5b51673d96d76d2d77a","30":"77e4d0c8934c2ba191f0","31":"b56ff0e7a938e7c3839f","32":"fccb628c4d0ddcdd2401","33":"5666ad48c029c4b53e3e","34":"47400a444d031a28d3ce","35":"46ac9dcfdc8bf20fd3b5","36":"a9fe7682a5c39475e588","37":"2078514b390431fb250f","38":"d2a957ef0bea6311fd42","39":"7ac217403625bcd65a13","40":"120f383b206f05b8109a","41":"ee557dcf42fe2e078fb6","42":"45bd8e22216dbc3ae139","43":"72562ceb5a5a733eef79","44":"1ab0ebb7e2676f6caa77","45":"5a5e5d50b11ac9f48395","46":"edc4ebb97a045ed9e890","47":"8aac7222c1945bf0a727","48":"ff97a0f1996d3400a803"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"7ba0e832607d0aa34fd3ebc09a03478bb7bac399","3":"c54ed03dbb5080e29b73f5cd699bbd2e6eb790cb","4":"29107295","5":"2250b53de61967a6264ef34daecfaae1ed32318b","7":"1a48f3500bfa2859c4c1d2b6b8d5e7f120402f3c","8":"framework","9":"4d4504f70e65bac4eb17d17380682e636cafe956","10":"742908874d139db3cdc84588064a532f1fc4363c","11":"7c89d84ff08ed2d15d93c4f3a12cda655939f09c","12":"fe03665ab55fd2276f5453ba23bb7f6ee7d5a005","17":"component---src-pages-404-js","18":"component---src-pages-about-js","19":"component---src-pages-brands-amplify-js","20":"component---src-pages-brands-index-js","21":"component---src-pages-brands-shops-js","22":"component---src-pages-brands-stack-media-js","23":"component---src-pages-brands-stackagency-js","24":"component---src-pages-case-study-entrepreneur-js","25":"component---src-pages-contact-js","26":"component---src-pages-index-js","27":"component---src-pages-publishers-affiliate-js","28":"component---src-pages-publishers-content-studio-js","29":"component---src-pages-publishers-index-js","30":"component---src-pages-publishers-self-serve-shops-js","31":"component---src-pages-publishers-shops-js","32":"component---src-pages-publishers-stack-media-js","33":"component---src-pages-publishers-stackagency-js","34":"component---src-templates-page-template-js","35":"components-sections-BrandsAmplifyDefer","36":"components-sections-BrandsIndexDefer","37":"components-sections-BrandsShopsDefer","38":"components-sections-BrandsStackAgencyDefer","39":"components-sections-BrandsStackMediaDefer","40":"components-sections-HomeDefer","41":"components-sections-PublishersAffiliateDefer","42":"components-sections-PublishersContentStudioDefer","43":"components-sections-PublishersIndexDefer","44":"components-sections-PublishersSelfShopsDefer","45":"components-sections-PublishersShopsDefer","46":"components-sections-PublishersStackAgencyDefer","47":"components-sections-PublishersStackMediaDefer","48":"forms-FooterNewsletter"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"f32cfb8dcf41333c6c07","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
